import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=5b932482&scoped=true"
import script from "./topBar.vue?vue&type=script&lang=js"
export * from "./topBar.vue?vue&type=script&lang=js"
import style0 from "./topBar.vue?vue&type=style&index=0&id=5b932482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b932482",
  null
  
)

export default component.exports